import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';

import { RouterStateUrl } from '../custom-route-serializer';

export interface GlobalState {
  router: RouterReducerState<RouterStateUrl>;
}

export const GlobalReducers: ActionReducerMap<GlobalState> = {
  router: routerReducer,
};
